import { useRef } from 'react';
import { AuthService } from '../services/auth/auth.service';

/**
 * It returns a instance of AuthService class wrapped in a React ref
 * @returns {AuthService}  A AuthService instance.
 */
export const useAuthService = (): AuthService => {
    const carRef = useRef<AuthService>();
    if (!carRef.current) {
        carRef.current = new AuthService();
    }
    return carRef.current;
};
